<template>
  <div
    class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
    style="background-image: url('https://images.empoweredconsumerism-static-files.com/ovi/website/images/landing_logo.png');
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;"
  >
    <!--begin::Content-->
    <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
      <!--begin::Logo-->
      <a href="#" class="mb-12">
        <img alt="Logo" src="media/ovi.webp" class="h-175px" />
      </a>
      <!--end::Logo-->
      <form
        id="app" 
        method="post"
        ref="ecopenform"
      >
      <input ref="username" type="hidden" v-model="username"  name="username"  />
      <input ref="password" type="hidden" v-model="password" name="password" />

      </form>
 
    </div>
    <!--end::Content-->

    <!--begin::Footer-->
    <div class="d-flex flex-center flex-column-auto p-10">
      <!--begin::Links-->
      <!-- div class="d-flex align-items-center fw-bold fs-6">
        <a href="#" class="text-muted text-hover-primary px-2">About</a>

        <a href="#" class="text-muted text-hover-primary px-2">Contact</a>

        <a href="#" class="text-muted text-hover-primary px-2">Contact Us</a>
      </div -->
      <!--end::Links-->
    </div>
    <!--end::Footer-->
  </div> 
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";

import { setCurrentUser, getCurrentUser } from '../../utils/index';
import { UserRole } from '../../utils/auth.roles';

import RegisterAccountModal from "@/views/auth/RegisterModal.vue";

import {get_up}  from "@/api/login";

export default defineComponent({
  name: "openec",
  components: {
    Field,
    Form,
    ErrorMessage,
    RegisterAccountModal
  },
  data() {
      return { 
        username: '',
        password: ''
      };
  }, 
  methods: {
     async checkForm() { 
     let rk = (len) =>{ 
          let text = ""
          let chars = "abcdefghijklmnopqrstuvwxyz1234567890" 
          for( let i=0; i < len; i++ ) {
                  text += chars.charAt(Math.floor(Math.random() * chars.length))
          } 
          return text; 
      };

       const response = await get_up({'x':'x'});
        if(response.data.efgqrst !== undefined && response.data.abcdxyz !== undefined) {  
          this.username = response.data.efgqrst ;
          this.password = response.data.abcdxyz;
          const self = this;
          setTimeout(function(){
                    const form:any = self.$refs.ecopenform;
                    form.action = "https://ec5.empoweredconsumerism.com/ecp/j_spring_security_check?zxx=" + rk(20);
                    form.submit();
                }, 500);

          
        }  

     }

  },
  mounted() {
    this.checkForm();
  }
});
</script>
